import { useEffect, useRef, useState } from 'react';
import Header from '../../components/Navigation/Header';
import './index.css';
import KnowledgeTestChart from '../../components/charts/knowledgetest';
import PsychometricTestChart from '../../components/charts/pyschometric';
import scrollButton from '../../Assets/scrollbutton.png';
import {  TestCompletionCheck } from '../../services/PyschometricQuestions';
import { KnowledgeTestCompletionCheck, ReceiveQuestions  as receiveKnowledge}  from '../../services/KnowledgeTest';
import { useLocation } from 'react-router-dom';
import view from '../../Assets/View.png';
import reportIcon from '../../Assets/carbon_report.png';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

function ViewDetailedReport()
{
    const [expand,setExpand]=useState({id:'',active:false});
    
    const [pyschometricCompleted,setPyschometricCompleted]=useState(false);
    const [knowledgeCompleted,setknowledgeCompleted]=useState(false);
    const location = useLocation();

        const fetchPyschometric=async()=>{
            const key=sessionStorage.getItem('PyschometricTestCompleted');
            if (key !== null) {
                setPyschometricCompleted(JSON.parse(key)); 
                return;
            }

            const questions=await TestCompletionCheck();
            console.log(questions,'pyscho');
            if(questions.success && questions?.data &&  questions?.data.completed===true)
            {
                setPyschometricCompleted(true);
                sessionStorage.setItem('PyschometricTestCompleted','true');
            } 
            else
            {
                setPyschometricCompleted(false);
                sessionStorage.setItem('PyschometricTestCompleted','false');
            }
        }
        const fetchKnowledge=async()=>{
            const key=sessionStorage.getItem('KnowledgeTestCompleted');
            if (key !== null) {
                setknowledgeCompleted(JSON.parse(key)); 
                return;
            }
            const questions=await KnowledgeTestCompletionCheck();
                        console.log('find',questions);

            if(questions.success && questions?.data && questions?.data.completed===true)
            {
                setknowledgeCompleted(true);
                sessionStorage.setItem('KnowledgeTestCompleted','true');
            } 
            else
            {
                setknowledgeCompleted(false);
                sessionStorage.setItem('KnowledgeTestCompleted','false');
            }
        }
        useEffect(() => {
            fetchPyschometric();
            fetchKnowledge();
        }, []);

        useEffect(() => {
            sessionStorage.removeItem("KnowledgeTestCompleted");
            sessionStorage.removeItem("PyschometricTestCompleted");
        
            fetchPyschometric();
            fetchKnowledge();
        }, [location.pathname]);    


        
    const psychometricRef = useRef(null);
    const knowledgeRef = useRef(null);
    const downloadCombinedPDF = async () => {
    const pdf = new jsPDF('landscape', 'pt', 'a4');
    
    // Temporarily adjust styles
    const psychoMinHeight = psychometricRef.current.style.minHeight;
    const knowMinHeight = knowledgeRef.current.style.minHeight;
    
    psychometricRef.current.style.minHeight = 'auto';
    knowledgeRef.current.style.minHeight = 'auto';
    psychometricRef.current.style.overflow = 'visible';
    knowledgeRef.current.style.overflow = 'visible';
    
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    const options = { 
        scale: 2, 
        useCORS: true,
        scrollY: 0
    };

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Page 1 - Psychometric chart
    const chart1Canvas = await html2canvas(psychometricRef.current, options);
    const img1 = chart1Canvas.toDataURL('image/png');
    const imgHeight1 = (chart1Canvas.height * pageWidth) / chart1Canvas.width;
    

    // Page 2 & 3 - Knowledge Test charts (split into 2 pages)
    const chart2Canvas = await html2canvas(knowledgeRef.current, options);
    const img2 = chart2Canvas.toDataURL('image/png');
    const imgHeight2 = (chart2Canvas.height * pageWidth) / chart2Canvas.width;
    
    pdf.addImage(img1, 'PNG', 0, 0, pageWidth, imgHeight1);

    // Add first page of Knowledge Test
    pdf.addPage();
    pdf.addImage(img2, 'PNG', 0, 0, pageWidth, imgHeight2);
    
    // If content is taller than one page, add continuation on next page
    if (imgHeight2 > pageHeight) {
        const remainingHeight = imgHeight2 - pageHeight;
        pdf.addPage();
        pdf.addImage(img2, 'PNG', 0, -pageHeight, pageWidth, imgHeight2);
    }
    
    // Restore styles
    psychometricRef.current.style.minHeight = psychoMinHeight;
    knowledgeRef.current.style.minHeight = knowMinHeight;
    psychometricRef.current.style.overflow = 'hidden';
    knowledgeRef.current.style.overflow = 'hidden';
    
    pdf.save('combined_charts.pdf');
};
        return(
        <>
        <Header/>
         <div className='pyschometrictestcontainer'>
             <section className='pyschometrictext'>
                <h2>View Detailed Report</h2>
                <h4><span >Home</span><span style={{color:'#8A090D'}}> &nbsp; &gt; Detailed Report</span></h4>
             </section>
             <section className='questionswipecontainer' style={{backgroundColor:"white"}}>
                <span className='expandablecontainer'>
                 <section className='expandablesection'>
                    <span className='drag'>
                        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                            <img src={reportIcon} alt='reportIcon' style={{marginRight:'5px'}}/>
                            <h4> Knowledge Test Score</h4>
                        </div>
                        <img src={view} alt="expandbutton"  className={expand.id=='knowledge' && expand.active ?'rotateButton':''} onClick={()=>setExpand(prev=>({id:'knowledge',active:!prev.active}))}/>
                    </span>
                   <div className='chart'> {expand.id=='knowledge'  &&  expand.active  ? knowledgeCompleted && <KnowledgeTestChart/> || <h4 style={{fontSize:"20px",fontWeight:"600"}}>Test Not Given</h4>:undefined} </div>
                 </section>
                 <section className='expandablesection'>
                    <span className='drag'>
                        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                            <img src={reportIcon} alt='reportIcon' style={{marginRight:'5px'}}/>
                            <h4> Pyschometric Test Score</h4>
                         </div>
                        <img src={view} alt="expandbutton" className={expand.id=='pyschometric' && expand.active ?'rotateButton':''} onClick={()=>setExpand(prev=>({id:'pyschometric',active:!prev.active}))}/>
                       
                    </span>
                   <div className='chart'> {expand.id=='pyschometric'  &&  expand.active  ? pyschometricCompleted && <PsychometricTestChart/> ||  <h4 style={{fontSize:"20px",fontWeight:"600"}}>Test Not Given</h4>:undefined  } </div>
                 </section>
                 {/* <section className='expandablesection'>
                    <span className='drag'>
                        <h4> Resume Analysis</h4>
                        <img src={scrollButton} alt="expandbutton" className={expand.id=='resumeanalysis' && expand.active ?'rotateButton':''} onClick={()=>setExpand(prev=>({id:'resumeanalysis',active:!prev.active}))}/>
                    </span>
                   <div className='chart'> {expand.id=='resumeanalysis'  &&  expand.active && <h4>Not Created</h4>} </div>
                 </section> */}
                 </span>
               <button onClick={downloadCombinedPDF}>DOWNLOAD REPORT</button>

             </section>
             <div className="offscreen-render">
                <div ref={knowledgeRef}>
                  <KnowledgeTestChart />
                </div>
                <div ref={psychometricRef}>
                   <PsychometricTestChart />
                </div>
              </div>
          </div>
        </>);
}

export default ViewDetailedReport;